module.exports = __webpack_public_path__ + "static/monster-801ed03592053d2f531d103d12a5fc44.svg";